import * as React from 'react';
import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import SEO from 'components/SEO';
import { SubCategoryShape } from 'utils/props';

import SubCategoryHero from 'pageComponents/Resources/SubCategoryHero';
import SubCategoryPostGrid from 'pageComponents/Resources/SubCategoryPostGrid';

function SubcategoryTemplate({ pageContext }) {
  const { category, subcategory } = pageContext;

  return (
    <Layout>
      <SubCategoryHero
        title={subcategory.title}
        description={subcategory.description}
        category={category}
      />
      <SubCategoryPostGrid posts={subcategory.posts} />
    </Layout>
  );
}

SubcategoryTemplate.propTypes = {
  pageContext: PropTypes.shape({
    category: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
    }),
    subcategory: SubCategoryShape,
  }),
};

export function Head({ location, pageContext }) {
  const { category, subcategory } = pageContext;

  return (
    <SEO
      title={subcategory.title}
      description={subcategory.seoDescription || subcategory.description}
      imageUrl={category.featuredPost?.featureImage?.image.asset.url}
      location={location}
    />
  );
}

export default SubcategoryTemplate;
